//system
import { Component, OnInit, ChangeDetectionStrategy, ViewChild, ElementRef } from '@angular/core';

//services
import { ApiRequestService } from '../../services/api-request.service';
import { UserInputParserService } from '../../services/user-input-parser.service';
import { MapRendererService } from '../../services/map-renderer.service';
import { FiltersService } from "../../services/filters.service";
import { RenderAndPreviewControllerService } from '../../services/render-and-preview-controller.service';
import { ClearDataService } from "../../services/clear-data.service";
import { CitySelectedService } from '../../services/city-selected.service';
import {Router, ActivatedRoute, Params} from '@angular/router';


//interfaces
import { MatchCities } from "../../interfaces/match-cities.interface";
import { City } from "../../interfaces/city.interface";
import { PostOfficeInfo } from 'src/app/interfaces/post-office-info.interface';



@Component({
  selector: 'search-input-group',
  //changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <div class="btn-group dropdown-group" >
    <input type="text" id="citySearch" class="routeInputs inline-block inputShorted " placeholder="Введіть населений пункт або індекс"
     (focus)="returnLastPrefixToSearchInput()" 
     (change)="searchWordHasChanged( searchWord );log('change')" 
     (keyup)="searchWordHasChanged( searchWord );log('up')" 
     [(ngModel)]="searchWord" autocomplete="off" />
    <ul id="dropdown-triggers-manual" class="cities-dropdown-menu"
    [hidden]="! isShowCitiesList || !cities ||cities.length === 0" role="menu" aria-labelledby="button-triggers-manual">
        <div *ngFor="let city of cities">
            <button type="button" class="dropdown-item" 
                (click)="isShowCitiesList = false; citySelected( city );log('slct')" >
                    {{city.SHORTCITYTYPE_UA}} 
                    {{city.CITY_UA}}, 
                    {{city.DISTRICT_UA}} р-н, 
                    {{city.REGION_UA}} обл.
            </button>
        </div>

    </ul>

    <button type="button"  (click)="isShowCitiesList = ! isShowCitiesList"
    class="btn btn-white dropdown-toggle-split dropButton greyDropdown" formnovalidate="formnovalidate">
        <i class="fas fa-caret-down"></i>
    </button>
    `,
  styleUrls: ['./search-input-group.component.sass']
})
export class SearchInputGroupComponent implements OnInit {
  // [ngClass]="dropdownButtonClass"
  public searchWord: string;
  public cities: any = [];
  public isShowCitiesList: boolean = false;
  public selectedCity: City;
  private lastSearchWord = null;
  private lastChangedWord = null;
  private previousInputLength = 0;
  public datePostIndex = undefined;
  //private allowedSymbols = /([a-zA-Z0-9 _-]+)/

  @ViewChild('citySearch', { static: true }) citySearch: ElementRef;

  constructor(
    private API: ApiRequestService,
    private inputParser: UserInputParserService,
    private map: MapRendererService,
    private filter: FiltersService,
    private controller: RenderAndPreviewControllerService,
    private clear: ClearDataService,
    private citySelectedServ: CitySelectedService,
    private activatedRoute: ActivatedRoute,
    //private renderer: Renderer2
  ) {

    this.activatedRoute.queryParams.subscribe(params => {
      let datePostIndex = params['postIndex'];
      if (datePostIndex == undefined){
        //console.log(datePostIndex); // Print the parameter index underfined to the console. 
      } else {
        this.searchWord = datePostIndex;
        this.inputParser.updateUsersInput(datePostIndex);
      }
    })

    this.activatedRoute.queryParams.subscribe(params => {
      let datePostCity = params['postCity'];
      if (datePostCity == undefined){
        //console.log(datePostCity); // Print the parameter сшен underfined to the console.
      } else {
        this.lastSearchWord = datePostCity;
        this.inputParser.updateUsersInput(this.lastSearchWord);
      }
    })

    API.getCityByPrefixSubject().asObservable().subscribe((newCities: MatchCities) => {
      if (newCities) {// rework for prefix check for slow connection 
        // no error
        // let lastUsersInput = this.inputParser.getLastValidUsersInput();
        // console.log(lastUsersInput);
        this.cities = newCities.cities;

        // console.log(newCities)

        let onlyOneMachingCity: any = null;
        let onlyMachingCity: any = null;
        
       
        if (newCities.isPrefixMatchOnlyOneCity) {
          onlyOneMachingCity = newCities.cities.filter((c: City) => {
            return c.CITY_UA.trim().toLocaleLowerCase() == this.lastSearchWord.trim().toLocaleLowerCase();
          });
        } 

        if (newCities) {
          onlyMachingCity = newCities.cities.filter((c: City) => {
            return c.CITY_UA.trim().toLocaleLowerCase() == this.lastSearchWord.trim().toLocaleLowerCase();
          });
        }


        let isAutoselectCity: boolean = newCities.citiesCount == 1 && newCities.cities[0].CITY_UA.trim().toLocaleLowerCase() == this.lastSearchWord.trim().toLocaleLowerCase() || newCities.isPrefixMatchOnlyOneCity && onlyOneMachingCity[0]
        let isAutoselectOneMany: boolean = newCities.cities[0].CITY_UA.trim().toLocaleLowerCase() == this.lastSearchWord.trim().toLocaleLowerCase() 

        if (isAutoselectCity && this.previousInputLength - newCities.cityPrefix.length < 0) {
          if (newCities.citiesCount == 1) {

            this.citySelected(newCities.cities[0])
            this.citySelectedServ.setSelectedCity(newCities.cities[0]);
            this.isShowCitiesList = false;

            document.getElementById('citySearch').blur()

          } else {
            if (newCities.isPrefixMatchOnlyOneCity) {
              this.citySelected(onlyOneMachingCity[0])
              this.citySelectedServ.setSelectedCity(onlyOneMachingCity[0]);
              this.isShowCitiesList = false;

              document.getElementById('citySearch').blur()
            } else {
              this.isShowCitiesList = true;
              this.citySelectedServ.clearSelectedCity();
            }

          }
        } else {
          this.isShowCitiesList = true;
          this.citySelectedServ.clearSelectedCity();
        }
      
      if(isAutoselectOneMany && this.previousInputLength - newCities.cityPrefix.length < 0) {
          this.citySelected(onlyMachingCity[0])
          this.citySelectedServ.setSelectedCity(onlyMachingCity[0]);
          this.isShowCitiesList = false;

          document.getElementById('citySearch').blur()
        } else {
          this.isShowCitiesList = true;
          this.citySelectedServ.clearSelectedCity();
        }

        this.previousInputLength = newCities.cityPrefix.length
      }
    })


    this.citySelectedServ.getSelectedCitySubject().asObservable().subscribe((c: City) => {

      if (c) {
        this.selectedCity = c
        this.searchWord = c.SHORTCITYTYPE_UA + ' ' + c.CITY_UA + ((c.DISTRICT_UA.includes('(місто)') ? '' : ', ' + c.DISTRICT_UA + ' р-н') + ', ' + c.REGION_UA + ' обл.');
      } else {
        this.selectedCity = null
      }
    })



    this.clear.getClearSubject().asObservable().subscribe((whatToClear: { Map: boolean, Dropdown: boolean, previewList: boolean, previewSelected: boolean, clearMapMessage: boolean }) => {
      if (whatToClear) {
        if (whatToClear.Dropdown) {
          this.cities = [];
        }
      }
    })

  }// constructor


  ngOnInit() {

  }

  log(a) {
    //console.log(a)
  }

  public searchWordHasChanged(newWord: string) {

    if (newWord && /^[0-9]$/.test(newWord))
      this.selectedCity = null

    if (this.lastSearchWord != newWord && this.lastChangedWord != newWord) {

      if (!this.selectedCity) // not write full city description into prefix
        this.lastSearchWord = newWord
      this.inputParser.updateUsersInput(newWord);

    }
    this.lastChangedWord = newWord;
  }

  public citySelected(city: City) {

    // console.log(city)

    this.controller.showNewCity(city);
    this.citySelectedServ.setSelectedCity(city)

  }

  public returnLastPrefixToSearchInput() {
    // console.log( this.searchWord , this.lastSearchWord )
    this.searchWord = this.lastSearchWord != null ? this.lastSearchWord : '';

  }

}